import type { FaireProductEntity } from "../../entity_types/product";

export const p_ua2773h7qv: FaireProductEntity = {
  token: "p_ua2773h7qv",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE BROWN",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/a9d069a14e9690f492f58ad286f6d77201a0e3e1d4fc2aeaba887f512ca9f910.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:10.189Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
